// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {
  Exact,
  OpenapiAccountBusinessTypeEnum,
  OpenapiAccountDashboardAccountStatusEnum,
  OpenapiAccountDashboardTypeEnum,
  Scalars,
  OpenapiAccountObjectFieldType,
  OpenapiAccountRiskRejectedReasonEnum,
  OpenapiAccountTypeEnum,
} from '@stripe-internal/data-v1/schema/types';
import {bankAccountExternalAccountFragment} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/bankAccountExternalAccountFragment';
import {cardExternalAccountFragment} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/cardExternalAccountFragment';
import {blockchainAddressExternalAccountFragment} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/blockchainAddressExternalAccountFragment';
import {financialAccountBalanceExternalAccountFragment} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/financialAccountBalanceExternalAccountFragment';
import type {BlockchainAddressExternalAccountFragmentData} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/blockchainAddressExternalAccountFragment';
import type {CardExternalAccountFragmentData} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/cardExternalAccountFragment';
import type {BankAccountExternalAccountFragmentData} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/bankAccountExternalAccountFragment';
import type {FinancialAccountBalanceExternalAccountFragmentData} from '@stripe-internal/connect-embedded-lib/dist/ExternalAccounts/queries/financialAccountBalanceExternalAccountFragment';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {additionalVerificationsArkFragment} from './additionalVerificationsArkFragment';
import {stripeAccountBusinessProfileArkFragment} from './stripeAccountBusinessProfileArkFragment';
import {stripeAccountCapabilitiesArkFragment} from './stripeAccountCapabilitiesArkFragment';
import {stripeLegalEntityCompanyArkFragment} from './stripeLegalEntityCompanyArkFragment';
import {stripeAccountRequirementsArkFragment} from './stripeAccountRequirementsArkFragment';
import {stripeAccountFutureRequirementsArkFragment} from './stripeAccountFutureRequirementsArkFragment';
import {stripeAccountTosAcceptanceArkFragment} from './stripeAccountTosAcceptanceArkFragment';
import {stripeLegalEntityIndividualArkFragment} from './stripeLegalEntityIndividualArkFragment';
import {stripeAccountSettingsArkFragment} from './stripeAccountSettingsArkFragment';
import {stripeAccountUnificationAccountControllerFragment} from './stripeAccountUnificationAccountControllerFragment';
import {stripeRedactedUserBasicFragment} from './stripeRedactedUserBasicFragment';

import type {AdditionalVerificationsArkFragmentData} from './additionalVerificationsArkFragment';
import type {StripeAccountBusinessProfileArkFragmentData} from './stripeAccountBusinessProfileArkFragment';
import type {StripeAccountCapabilitiesArkFragmentData} from './stripeAccountCapabilitiesArkFragment';
import type {StripeLegalEntityCompanyArkFragmentData} from './stripeLegalEntityCompanyArkFragment';
import type {StripeAccountFutureRequirementsArkFragmentData} from './stripeAccountFutureRequirementsArkFragment';
import type {StripeLegalEntityIndividualArkFragmentData} from './stripeLegalEntityIndividualArkFragment';
import type {StripeAccountRequirementsArkFragmentData} from './stripeAccountRequirementsArkFragment';
import type {StripeAccountSettingsArkFragmentData} from './stripeAccountSettingsArkFragment';
import type {StripeAccountTosAcceptanceArkFragmentData} from './stripeAccountTosAcceptanceArkFragment';
import type {StripeAccountUnificationAccountControllerFragmentData} from './stripeAccountUnificationAccountControllerFragment';
import type {StripeRedactedUserBasicFragmentData} from './stripeRedactedUserBasicFragment';

const doc = gql`
  fragment StripeAccountArkFragment on OpenapiAccount {
    id
    active_payment_methods
    additional_verifications {
      ...AdditionalVerificationsArkFragment
    }
    business_dba
    business_profile {
      ...StripeAccountBusinessProfileArkFragment
    }
    business_type
    can_unset_representative
    can_generate_remediation_link
    capabilities {
      ...StripeAccountCapabilitiesArkFragment
    }
    charges_enabled
    company {
      ...StripeLegalEntityCompanyArkFragment
    }
    controlling_platform
    controlling_platform_can_draw_funds
    controlling_platform_has_risk_controls
    country
    created
    dashboard_account_status
    dashboard_type
    default_account_holder_name
    default_currency
    details_submitted
    email
    email_confirmed
    external_account_changes_disabled
    external_accounts {
      data {
        ...BlockchainAddressExternalAccountFragment
        ...CardExternalAccountFragment
        ...BankAccountExternalAccountFragment
        ...FinancialAccountBalanceExternalAccountFragment
      }
    }
    fake_account
    future_requirements {
      ...StripeAccountFutureRequirementsArkFragment
    }
    individual {
      id
      ...StripeLegalEntityIndividualArkFragment
    }
    invoice_settings {
      days_until_due
      description
      footer
      payment_methods_enabled_for_merchant {
        ach_credit_transfer
        acss_debit
        afterpay_clearpay
        alipay
        au_becs_debit
        bancontact
        boleto
        card
        customer_balance
        eps
        fpx
        giropay
        grabpay
        id_bank_transfer
        id_credit_transfer
        ideal
        jp_credit_transfer
        konbini
        link
        netbanking
        p24
        paper_check
        paynow
        paypal
        promptpay
        sepa_credit_transfer
        sepa_debit
        sofort
        upi
        us_bank_account
        wechat_pay
      }
    }
    legal_entity_shared_with
    login_links
    merchant_reonboarded_from
    merchants_reonboarded_to
    nickname
    object
    payouts_enabled
    phone_verification
    proration_settings {
      smart_prorations
    }
    requirements {
      ...StripeAccountRequirementsArkFragment
    }
    risk_rejected_reason
    settings {
      ...StripeAccountSettingsArkFragment
    }
    stripe_owns_card_payments_pricing
    stripe_owns_lpm_payments_pricing
    stripe_owns_onboarding
    tos_acceptance {
      ...StripeAccountTosAcceptanceArkFragment
    }
    type
    unified_account
    controller {
      ...StripeAccountUnificationAccountControllerFragment
    }
    metadata
    org
    primary_user {
      id
      ...StripeRedactedUserBasicFragment
    }
  }

  ${additionalVerificationsArkFragment}
  ${stripeAccountBusinessProfileArkFragment}
  ${stripeAccountCapabilitiesArkFragment}
  ${stripeLegalEntityCompanyArkFragment}
  ${stripeAccountRequirementsArkFragment}
  ${stripeAccountFutureRequirementsArkFragment}
  ${stripeAccountTosAcceptanceArkFragment}
  ${stripeLegalEntityIndividualArkFragment}
  ${stripeAccountSettingsArkFragment}
  ${blockchainAddressExternalAccountFragment}
  ${cardExternalAccountFragment}
  ${bankAccountExternalAccountFragment}
  ${financialAccountBalanceExternalAccountFragment}
  ${stripeAccountUnificationAccountControllerFragment}
  ${stripeRedactedUserBasicFragment}
`;

export const stripeAccountArkFragment: StripeAccountArkFragmentDocument = doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountArkFragmentData = {
  readonly __typename: 'OpenapiAccount';
  readonly id: string;
  readonly active_payment_methods: ReadonlyArray<string> | null;
  readonly business_dba: string | null;
  readonly business_type: OpenapiAccountBusinessTypeEnum | null;
  readonly can_unset_representative: boolean | null;
  readonly can_generate_remediation_link: boolean | null;
  readonly charges_enabled: boolean;
  readonly controlling_platform: string | null;
  readonly controlling_platform_can_draw_funds: boolean | null;
  readonly controlling_platform_has_risk_controls: boolean | null;
  readonly country: string;
  readonly created: number | null;
  readonly dashboard_account_status: OpenapiAccountDashboardAccountStatusEnum | null;
  readonly dashboard_type: OpenapiAccountDashboardTypeEnum | null;
  readonly default_account_holder_name: string | null;
  readonly default_currency: string;
  readonly details_submitted: boolean;
  readonly email: string | null;
  readonly email_confirmed: boolean | null;
  readonly external_account_changes_disabled: boolean;
  readonly fake_account: boolean;
  readonly legal_entity_shared_with: ReadonlyArray<string> | null;
  readonly login_links: Scalars['JSONObject'] | null;
  readonly merchant_reonboarded_from: string | null;
  readonly merchants_reonboarded_to: ReadonlyArray<string> | null;
  readonly nickname: string | null;
  readonly object: OpenapiAccountObjectFieldType;
  readonly payouts_enabled: boolean;
  readonly phone_verification: Scalars['JSONObject'] | null;
  readonly risk_rejected_reason: OpenapiAccountRiskRejectedReasonEnum | null;
  readonly stripe_owns_card_payments_pricing: boolean | null;
  readonly stripe_owns_lpm_payments_pricing: boolean | null;
  readonly stripe_owns_onboarding: boolean | null;
  readonly type: OpenapiAccountTypeEnum;
  readonly unified_account: boolean | null;
  readonly metadata: Scalars['JSONObject'] | null;
  readonly org: string | null;
  readonly additional_verifications: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiAdditionalVerificationsResourceAdditionalVerifications';
    },
    [AdditionalVerificationsArkFragmentData]
  > | null;
  readonly business_profile: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountBusinessProfile'},
    [StripeAccountBusinessProfileArkFragmentData]
  > | null;
  readonly capabilities: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountCapabilities'},
    [StripeAccountCapabilitiesArkFragmentData]
  > | null;
  readonly company: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityCompany'},
    [StripeLegalEntityCompanyArkFragmentData]
  > | null;
  readonly external_accounts: {
    readonly __typename: 'OpenapiAccountExternalAccounts';
    readonly data: ReadonlyArray<
      GraphQlFragmentUnion<
        | {
            readonly __typename: 'OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddress';
          }
        | {readonly __typename: 'OpenapiExternalAccountBankAccount'}
        | {readonly __typename: 'OpenapiExternalAccountCard'}
        | {
            readonly __typename: 'OpenapiExternalAccountFinancialAccountBalance';
          },
        [
          BlockchainAddressExternalAccountFragmentData,
          CardExternalAccountFragmentData,
          BankAccountExternalAccountFragmentData,
          FinancialAccountBalanceExternalAccountFragmentData,
        ]
      >
    >;
  } | null;
  readonly future_requirements: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountFutureRequirements'},
    [StripeAccountFutureRequirementsArkFragmentData]
  > | null;
  readonly individual: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityIndividual'; readonly id: string},
    [StripeLegalEntityIndividualArkFragmentData]
  > | null;
  readonly invoice_settings: {
    readonly __typename: 'OpenapiInvoiceSettingAccountSetting';
    readonly days_until_due: number | null;
    readonly description: string | null;
    readonly footer: string | null;
    readonly payment_methods_enabled_for_merchant: {
      readonly __typename: 'OpenapiInvoiceSettingSupportedPaymentMethods';
      readonly ach_credit_transfer: boolean | null;
      readonly acss_debit: boolean | null;
      readonly afterpay_clearpay: boolean | null;
      readonly alipay: boolean | null;
      readonly au_becs_debit: boolean | null;
      readonly bancontact: boolean | null;
      readonly boleto: boolean | null;
      readonly card: boolean | null;
      readonly customer_balance: boolean | null;
      readonly eps: boolean | null;
      readonly fpx: boolean | null;
      readonly giropay: boolean | null;
      readonly grabpay: boolean | null;
      readonly id_bank_transfer: boolean | null;
      readonly id_credit_transfer: boolean | null;
      readonly ideal: boolean | null;
      readonly jp_credit_transfer: boolean | null;
      readonly konbini: boolean | null;
      readonly link: boolean | null;
      readonly netbanking: boolean | null;
      readonly p24: boolean | null;
      readonly paper_check: boolean | null;
      readonly paynow: boolean | null;
      readonly paypal: boolean | null;
      readonly promptpay: boolean | null;
      readonly sepa_credit_transfer: boolean | null;
      readonly sepa_debit: boolean | null;
      readonly sofort: boolean | null;
      readonly upi: boolean | null;
      readonly us_bank_account: boolean | null;
      readonly wechat_pay: boolean | null;
    } | null;
  };
  readonly proration_settings: {
    readonly __typename: 'OpenapiInvoiceSettingProrationSetting';
    readonly smart_prorations: boolean | null;
  };
  readonly requirements: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountRequirements'},
    [StripeAccountRequirementsArkFragmentData]
  > | null;
  readonly settings: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountSettings'},
    [StripeAccountSettingsArkFragmentData]
  > | null;
  readonly tos_acceptance: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountTosAcceptance'},
    [StripeAccountTosAcceptanceArkFragmentData]
  > | null;
  readonly controller: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountUnificationAccountController'},
    [StripeAccountUnificationAccountControllerFragmentData]
  > | null;
  readonly primary_user: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiRedactedUserBasic'; readonly id: string},
    [StripeRedactedUserBasicFragmentData]
  > | null;
};

export type StripeAccountArkFragmentVariables = Exact<{[key: string]: never}>;

const stripeAccountArkFragmentPermissions = {
  ...additionalVerificationsArkFragment.permissions,
  ...bankAccountExternalAccountFragment.permissions,
  ...blockchainAddressExternalAccountFragment.permissions,
  ...cardExternalAccountFragment.permissions,
  ...financialAccountBalanceExternalAccountFragment.permissions,
  ...stripeAccountBusinessProfileArkFragment.permissions,
  ...stripeAccountCapabilitiesArkFragment.permissions,
  ...stripeAccountFutureRequirementsArkFragment.permissions,
  ...stripeAccountRequirementsArkFragment.permissions,
  ...stripeAccountSettingsArkFragment.permissions,
  ...stripeAccountTosAcceptanceArkFragment.permissions,
  ...stripeAccountUnificationAccountControllerFragment.permissions,
  ...stripeLegalEntityCompanyArkFragment.permissions,
  ...stripeLegalEntityIndividualArkFragment.permissions,
  ...stripeRedactedUserBasicFragment.permissions,
} as const;

doc.permissions = stripeAccountArkFragmentPermissions;

export type StripeAccountArkFragmentPermissions = V1PermissionToken<
  typeof stripeAccountArkFragmentPermissions
>;

export type StripeAccountArkFragmentDocument = GraphQlDocument<
  StripeAccountArkFragmentData,
  StripeAccountArkFragmentVariables,
  StripeAccountArkFragmentPermissions
>;
